import History from './history';

const servicesTexts = {
  ...History,
};

export type TServicesTexts = typeof servicesTexts;

export default servicesTexts;
